export const SETUP_STEP_KEYS = {
  database: "Add a database configuration.",
  instructions: "Add general instructions.",
  expressions: "Add SQL expressions.",
  queries: "Add query instructions.",
};

export function getPendingSetupItems(setupStatus) {
  if (!setupStatus || setupStatus.minimum_setup_complete !== false) {
    return [];
  }

  const items = [];

  if (!setupStatus.has_database_config) {
    items.push(SETUP_STEP_KEYS.database);
  }
  if (!setupStatus.has_general_instruction) {
    items.push(SETUP_STEP_KEYS.instructions);
  }
  if (setupStatus.sql_expression_applicable !== false && !setupStatus.has_sql_expression) {
    items.push(SETUP_STEP_KEYS.expressions);
  }
  if (setupStatus.query_instruction_applicable !== false && !setupStatus.has_query_instruction) {
    items.push(SETUP_STEP_KEYS.queries);
  }

  return items;
}

